<template>
  <div>
    <div class="sub_title">
      <div>
        Beneficiary Information
        <el-tooltip placement="top">
          <div slot="content">
            1. Please ensure that the beneficiary's account is true, accurate, and
            carefully distributed;<br />2. After the Rep is minted successfully, it will
            be automatically sent to the beneficiary's account according to the ratio you
            set.
          </div>
          <!-- <el-button icon="el-icon-question" type="text"></el-button> -->
          <svg-icon icon-class="ts"></svg-icon>
        </el-tooltip>
      </div>
      <el-button type="text" @click="handleAdd" v-if="shareList.length < 10">
        <svg-icon icon-class="share_add"></svg-icon>
        Add new beneficiary
      </el-button>
    </div>
    <el-table :data="shareList">
      <el-table-column label="No." align="center" width="100">
        <template slot-scope="scope">
          <svg-icon
            icon-class="share_user"
            v-if="scope.row.address === $store.getters.metaMaskObj.account"
          ></svg-icon>
          {{ scope.$index + 1 }}
          <span v-if="scope.row.address === $store.getters.metaMaskObj.account"
            >(YOU)</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="address" label="Beneficiar">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.address"
            :disabled="row.address === $store.getters.metaMaskObj.account"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="ratio" label="Benefit ratio" width="200">
        <template slot-scope="{ row }">
          <el-input
            v-model.number="row.ratio"
            :disabled="row.address === $store.getters.metaMaskObj.account"
            @change="getOwnRatio(row)"
          >
            <template slot="append">%</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column width="200">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.address !== $store.getters.metaMaskObj.account"
            type="text"
            @click="handleDel(scope.$index)"
            icon="el-icon-delete"
            >Delete</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {},
  data() {
    return {
      producerContract: undefined,
      producerAddress: undefined,
      gasContract: undefined,
      gasAddress: undefined,
      shareList: [],
    };
  },
  methods: {
    handleAdd() {
      let len = this.shareList.length;
      if (this.shareList[len - 1].address == "") {
        this.$message.error(`Please fill in item ${len} of the data first`);
        return false;
      }
      this.shareList.push({
        address: "",
        ratio: 0,
      });
    },
    handleDel(index) {
      this.shareList.splice(index, 1);
      this.getOwnRatio();
    },
    getOwnRatio(row) {
      let otherList = this.shareList.filter(
        (item) => item.address !== this.$store.getters.metaMaskObj.account
      );
      let otherTotal = otherList.reduce((pre, cur) => pre + Number(cur.ratio), 0);
      if (row) {
        if (!isNaN(row.ratio) && row.ratio >= 0 && row.ratio <= 100) {
          if (otherTotal >= 100) {
            row.ratio = 0;
          } else {
            this.shareList[0].ratio = 100 - otherTotal;
          }
        } else {
          row.ratio = 0;
        }
      } else {
        this.shareList[0].ratio = 100 - otherTotal;
      }
    },
    getData(flag, i) {
      let addressArr = [],
        ratioArr = [];
      let otherList = this.shareList.filter(
        (item) => item.address !== this.$store.getters.metaMaskObj.account
      );
      otherList.forEach((item) => {
        addressArr.push(item.address.toLowerCase());
        ratioArr.push(item.ratio);
      });
      let newAddressArr = [...new Set(addressArr)];
      if (newAddressArr.length < ratioArr.length  || newAddressArr.includes(this.shareList[0].address))  {
        if (flag) {
          this.$message.error(
            `This beneficiary already exists in well${i + 1}, please do not repeat!`
          );
        } else {
          this.$message.error(
            "This beneficiary already exists in this well, please do not repeat!"
          );
        }
        return false;
      }
      return {
        addressArr: addressArr,
        ratioArr: ratioArr,
      };
    },
    shareCheck() {
      return new Promise((resolve, reject) => {
        let len = this.shareList.length;
        if (this.shareList[len - 1].address == "") {
          this.$message.error(`Please fill in item ${len} of the data`);
          reject();
          return false;
        }
        if (!this.getData()) {
          reject();
          return false;
        }
        resolve();
      });
    },
    pointShareCheck(i) {
      let len = this.shareList.length;
      if (this.shareList[len - 1].address == "") {
        this.$message.error(
          `well${i + 1} beneficiary information: Please fill in item ${len} of the data`
        );
        return false;
      }
      return this.getData(true, i);
    },
    submite(contract,address,uniqueId) {
      return new Promise((resolve, reject) => {
        let data = this.getData();
        console.log(data)
        const tx_builder = contract.methods["setHolders"](
          uniqueId,
          data.addressArr,
          data.ratioArr
        );
        const encoded_tx = tx_builder.encodeABI();

        let json = {
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: address,
          value: 0,
          data: encoded_tx,
        };
        web3.eth
          .sendTransaction(json)
          .then((res) => {
            resolve();
          })
          .catch((error) => {
            reject();
            this.$message.error("operation failed");
            console.error(error);
          });
      });
    },
  },
  created() {
    // this.getAbi("OilProducer").then((res) => {
    //   this.producerContract = new web3.eth.Contract(res.result.abi, res.result.address);
    //   this.producerAddress = res.result.address;
    // });
    // this.getAbi("GasProducer").then((res) => {
    //   this.gasContract = new web3.eth.Contract(res.result.abi, res.result.address);
    //   this.gasAddress = res.result.address;
    // });
    this.shareList.push({
      address: this.$store.getters.metaMaskObj.account,
      ratio: 100,
    });
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
.sub_title {
  font-size: 0.18rem;
  font-family: Roboto-Bold, Roboto;
  font-weight: bold;
  color: #000000;
  line-height: 0.28rem;
  margin-bottom: 0.16rem;
  display: flex;
  justify-content: space-between;
}
</style>
